import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { SIZES } from "../constants";
import getImageSize from "../utils/getImageSize";
import getPreviewModalMaxSize from "../utils/getPreviewModalMaxSize";
const defaultPreviewSettings = {
    show: false,
    inProgress: false,
    src: "",
    width: 0,
    height: 0
};
export default function Image(props) {
    const [previewSettings, setPreviewSettings] = useState(defaultPreviewSettings);
    const popupRef = useRef(null);
    useEffect(() => {
        if (!props.show || !props.src) {
            setPreviewSettings(prev => ({ ...prev, inProgress: false, show: false }));
            return;
        }
        const imgSrc = props.src;
        getImageSize(imgSrc, (width, height) => {
            var _a;
            if (!((_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.instance))
                return;
            setPreviewSettings({
                show: true,
                inProgress: false,
                src: imgSrc,
                width,
                height
            });
        }, () => {
            var _a;
            if (!((_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.instance))
                return;
            const { maxHeight: defaultHeight, maxWidth: defaultWidth } = getPreviewModalMaxSize(false);
            setPreviewSettings({
                show: true,
                inProgress: false,
                src: imgSrc,
                width: defaultWidth,
                height: defaultHeight
            });
        });
    }, [props.show, props.src]);
    const imageContainerStyle = useMemo(() => ({
        width: previewSettings.width,
        height: previewSettings.height,
        transition: "all 0.2s linear"
    }), [previewSettings.width, previewSettings.height]);
    return (React.createElement(WithModal, { show: previewSettings.show, popupRef: popupRef, onHide: props.onHide, shadingColor: shadingLightestColor, className: "bg-blur", maxHeight: `calc(100vh - ${SIZES.PREVIEW_WINDOW_OFFSET * 2}px)`, maxWidth: `calc(100vw - ${SIZES.PREVIEW_WINDOW_OFFSET * 2}px)`, width: "auto", height: "auto", resizeEnabled: false, dragEnabled: false, title: props.title, headerOutsideModal: true, showTitle: true, closeBtn: true, isLoading: previewSettings.inProgress, contentClassName: "h-center-items" },
        React.createElement("div", { style: imageContainerStyle, className: "flex-box-centered-content" }, previewSettings.src && (React.createElement("img", { className: "img-contain", width: "100%", height: "100%", src: previewSettings.src, title: "", alt: "" })))));
}
